module.exports = __webpack_public_path__ + "static/media/dice-d4.fbed3ac3.svg";